import React, {Component} from 'react';
import {TabContent, TabPane, Nav, NavItem, NavLink, Progress, Label, Input} from 'reactstrap';
import classnames from 'classnames';
import { inject, observer } from "mobx-react";
import moment from 'moment';

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

@inject("userStore", "notifyStore") @observer
class Aside extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  componentDidMount = async () => {
    const { userStore, notifyStore } = this.props;
    await userStore.onReady();
    await notifyStore.getList(userStore.userData.id);
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  markAllAsRead = async (e) => {
    !!e && e.preventDefault();
    const { notifyStore, userStore } = this.props;
    await notifyStore.markAllAsRead({userId: userStore.userData.id});
  };

  markOneAsRead = async (e, item) => {
    !!e && e.preventDefault();
    const { notifyStore } = this.props;
    await notifyStore.markOneAsRead({notiId: item.id, userId: item.userId});
  };

  renderNotify = (items = []) => {
    return (
      items.map((item, index) => {
        return (
          <div key={'notify'+index}>
            <div className={!!item.read ? 'message' : 'message unread'}>
              {/*<div className="py-3 pb-5 mr-3 float-left">*/}
                {/*<div className="avatar">*/}
                  {/*<img className="img-circle" src={defaultImage} alt="user_name" />*/}
                  {/*<span className="avatar-status badge-success"> </span>*/}
                {/*</div>*/}
              {/*</div>*/}
              <div className="message__time">
                <small className="text-muted">{moment(new Date(item.timestamp)).fromNow()}</small>
                {/*<small className="text-muted float-right mt-1"> </small>*/}
              </div>
              {/*<div className="text-truncate font-weight-bold">{item.title}</div>*/}
              <p className="message__content">{item.body}</p>
              <div className="message__link">
                <small>
                  {!!item.read ? <span> </span> :
                    <span className="text-muted mark-as-read" onClick={e => this.markOneAsRead(e, item)}>
                      Mark as read
                    </span>
                  }
                  <a target="_blank" href={item.data.linkWeb}> Web </a>
                  <a target="_blank" href={item.data.linkMobile} > Mobile </a>
                </small>
              </div>
            </div>
          </div>
        )
      })
    )
  };

  render() {
    const { notifyStore } = this.props;
    const allNoti = notifyStore.listNotify || [];
    const listRead = allNoti.filter(item => item.read === true);
    const listUnread = allNoti.filter(item => item.read !== true);

    return (
      <aside className="aside-menu notification">
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                     onClick={() => { this.toggle('1'); }}>
              <span>All</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '2' })}
                     onClick={() => { this.toggle('2'); }}>
              <span>Read</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '3' })}
                     onClick={() => { this.toggle('3'); }}>
              <span>Unread</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <span title="Mark all as read" className="text-success icon-mark-all-as-read" onClick={e => this.markAllAsRead(e)}>
              <i className="fa fa-check-square-o" aria-hidden="true"> </i>
            </span>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1" className="notify-tab-list">
            {this.renderNotify(allNoti)}
          </TabPane>
          <TabPane tabId="2" className="notify-tab-list">
            {this.renderNotify(listRead)}
          </TabPane>
          <TabPane tabId="3" className="notify-tab-list">
            {this.renderNotify(listUnread)}
          </TabPane>
        </TabContent>
      </aside>
    )
  }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js